import React from 'react';

export function PlanFormWarnings({ planId, formik }) {
  return (
    <>
      {planId ? (
        <div className="alert alert-warning mb-5" role="alert">
          <strong>Modo edição.</strong> Você está alterando um plano já
          cadastrado. Revise os dados antes de salvar.
        </div>
      ) : null}
      {planId ? (
        <div
          className="alert alert-light border border-info text-dark mb-5"
          role="alert"
        >
          <strong className="text-info">Valor do plano e o que pode ser editado</strong>
          <ul className="mb-0 mt-3 pl-3">
            <li className="mb-2">
              Para cobrar outro valor, o caminho recomendado é{' '}
              <strong>criar um plano/cupom novo</strong>,
              conforme a estratégia comercial da operação.
            </li>
            <li className="mb-0">
              <strong>Os demais atributos</strong> do plano podem ser{' '}
              <strong>alterados normalmente</strong> aqui.
            </li>
          </ul>
        </div>
      ) : null}
    </>
  );
}
